export default "__VITE_ASSET__BnBu7Qo5__"